import { EventBus } from 'utils/event-bus';
import { handleUploadTextFile } from './UploadTextFile';

export const handleValidateFileUpload = (files, tinyMCE, fileUploader) => {
  if (files[0].size > 5000000) {
    EventBus.$emit('toast-msg', 'Invalid file size. (Max. 5MB)');
    return;
  }
  handleUploadTextFile(files, tinyMCE, fileUploader);
};


// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/EditorMCE/Utils/ValidateFileUpload.js